// timings to remind expiration of discovery offers, in days
export const expirationReminders = [13, 7, 1];

export const soundEnabledBydefault = process.env.NODE_ENV !== 'production';

export const forceDefaultLanguageOnFirstConnection = false;

export const selectLanguageOnFirstConnection = false;
